<p class="my-3 text-muted" *ngIf="showRequiredFieldsGuidance">
    <ng-container *ngIf="translationsSupported; else translationsNotSupported">
        <span class="text-danger">*</span> {{'indicates a required field' | translate}}
    </ng-container>
    <ng-template #translationsNotSupported>
        <span class="text-danger">*</span> indicates a required field
    </ng-template>
</p>